import React, { useEffect, useState } from 'react'
import Page from 'src/components/Page'
import {
    Grid,
    Button,
    Paper,
    TextField,
    Typography,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    Collapse,
    Container,
    Snackbar
} from '@material-ui/core'
import Alert from 'src/components/Alert';
import { Skeleton } from '@mui/material'
import { makeStyles, styled } from '@material-ui/core/styles'
import axios from 'src/utils/axios'
import { getUser } from 'src/utils/Common'
import moment from 'moment'
import { useHistory } from 'react-router'

const useStyles = makeStyles((theme) => ({
    container: {
        overflow: 'auto',
        maxHeight: '90vh'
    },
    mainGridItem: {
        marginTop: '2rem',
    },
    paper: {
        borderRadius: '0.5rem',
    },
    header: {
        backgroundColor: '#0033a0',
        color: '#fff',
        borderTopRightRadius: '0.5rem',
        borderTopLeftRadius: '0.5rem',
    },
    headerTypography: {
        marginTop: '0.5rem',
        marginBottom: '0.5rem',
        color: '#fff',
    },
    textFieldGrid: {
        margin: '1rem 0',
    },
    buttonGrid: {
        marginTop: '2rem',
        borderRadius: '0.5rem',
    },
    tableHeadRow: {
        backgroundColor: '#0033a0',
        color: '#fff',
    },
    tableCell: {
        borderRight: '1px solid #ddd',
    },
    tableText: {
        color: '#fff',
    },
    noteTypography: {
        marginTop: '0.5rem',
        marginBottom: '0.5rem',
    },
}));

function MultipleReceiptInquiry() {
    const classes = useStyles();
    const history = useHistory();
    const SessionUser = getUser();

    const [totalReceiptNumber, setTotalReceiptNumber] = React.useState(0);
    const [receiptNumbers, setReceiptNumbers] = React.useState('');
    const [generalData, setGeneralData] = React.useState([]);

    const [isVisible, setIsVisible] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    useEffect(() => {
        // Sayfa yüklendiğinde veya bileşen oluşturulduğunda önceki sayfa yolunu kontrol eder
        const previousPath = localStorage.getItem('previousPath');
        console.log(previousPath);
        if (previousPath === '/SarisQueries/ReceiptDetails') {
            setTotalReceiptNumber(Number(localStorage.getItem('totalReceiptNumber')) || 0);
            setReceiptNumbers(localStorage.getItem('receiptNumbers') || '');
            setGeneralData(JSON.parse(localStorage.getItem('generalData')) || []);
            setIsVisible(localStorage.getItem('isVisible') === 'true');
        }
    }, []);

    useEffect(() => {
        // Durum (state) değerleri değiştiğinde yerel depolamaya kaydedilir
        localStorage.setItem('totalReceiptNumber', totalReceiptNumber);
        localStorage.setItem('receiptNumbers', receiptNumbers);
        localStorage.setItem('generalData', JSON.stringify(generalData));
        localStorage.setItem('isVisible', isVisible);

        // Geçerli sayfa yolunu yerel depolamaya kaydeder
        localStorage.setItem('previousPath', history.location.pathname);
    }, [totalReceiptNumber, receiptNumbers, generalData, isVisible]);

    const handleButtonClick = () => {
        if (receiptNumbers.length <= 0) {
            setresponseMessage('Lütfen Fiş Numarası alanını boş bırakmayınız!...');
            setUyariTip('warning');
            setUyari(true);
            return;
        }
        setIsVisible(true);
        const value = receiptNumbers;
        const commaSeparated = value.split('\n').filter(Boolean).join(',');
        getReceiptsData(commaSeparated);
    };

    const getReceiptsData = (commaSeparated) => {
        setLoading(true);
        axios.get(`GetMultipleReceiptList/${commaSeparated}`)
            .then((response) => {
                var data = response.data;
                let counter = data.length;

                setTotalReceiptNumber(counter);
                setGeneralData(data);

                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const clearEverything = () => {
        setReceiptNumbers('');
        setGeneralData([]);
        setIsVisible(false);
    }

    const handleRowClick = (ReceiptNumber) => {
        history.push(`/SarisQueries/ReceiptDetails/${ReceiptNumber}`);
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    return (
        <>
            <Snackbar
                open={uyari}
                autoHideDuration={5000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Grid container spacing={1} className={classes.container}>
                <Grid item xs={false} sm={false} md={2} />
                <Grid item xs={12} sm={12} md={8}>
                    <Page title={'Fiş Sorgu Toplu'} className={classes.mainGridItem}>
                        <Paper elevation={3} className={classes.paper}>
                            <Grid container>
                                <Grid item xs={12} className={classes.header}>
                                    <Typography
                                        variant='h3'
                                        align='center'
                                        gutterBottom
                                        className={classes.headerTypography}
                                    >
                                        {'Toplu Fiş Listesi'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={false} sm={false} md={3} />
                                <Grid item xs={12} sm={12} md={6} className={classes.textFieldGrid}>
                                    <TextField
                                        label='Fiş Numaraları'
                                        variant='outlined'
                                        fullWidth
                                        multiline
                                        minRows={15}
                                        value={receiptNumbers}
                                        onChange={(event) => { setReceiptNumbers(event.target.value); }}
                                    />
                                </Grid>
                                <Grid item xs={false} sm={false} md={3} />
                                <Grid container spacing={1}>
                                    <Grid item xs={3} sm={3} md={3} />
                                    <Grid item xs={3} sm={3} md={3}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => { handleButtonClick(); }}
                                            fullWidth
                                        >
                                            GÖNDER
                                        </Button>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            fullWidth
                                            onClick={() => { clearEverything(); }}
                                        >
                                            TEMİZLE
                                        </Button>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} />
                                    <Grid item xs={12}>
                                        <Typography
                                            variant='subtitle2'
                                            align='center'
                                            gutterBottom
                                            className={classes.noteTypography}
                                        >
                                            {'*Fiş numaralarını her satıra bir fiş gelecek şekilde yazınız. (Ya da Excel\'den column seçerek paste ediniz)'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Collapse in={isVisible}>
                            <Paper elevation={3} className={classes.buttonGrid}>
                                <TableContainer component={Paper} className={classes.buttonGrid}>
                                    <Table size='small'>
                                        <TableHead>
                                            <TableRow className={classes.tableHeadRow}>
                                                <TableCell colSpan={7}>
                                                    <Typography variant="h5" className={classes.tableText}>
                                                        {`Toplamda ${totalReceiptNumber} adet fiş bulundu`}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={classes.tableCell}>Fiş Numarası</TableCell>
                                                <TableCell className={classes.tableCell}>Servis Kodu</TableCell>
                                                <TableCell className={classes.tableCell}>Çağrı Tarihi</TableCell>
                                                <TableCell className={classes.tableCell}>İşlem Tarihi</TableCell>
                                                <TableCell className={classes.tableCell}>Ürün</TableCell>
                                                <TableCell className={classes.tableCell}>Başvuru Nedeni</TableCell>
                                                <TableCell>Durum</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {loading ? (
                                                Array.from(new Array(3)).map((_, index) => (
                                                    <TableRow key={index}>
                                                        {Array.from(new Array(7)).map((_, cellIndex) => (
                                                            <TableCell key={cellIndex} colSpan={1}>
                                                                <Skeleton animation="pulse" variant="text" />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))
                                            ) : (
                                                generalData.length > 0 && generalData.map((data, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell
                                                            className={classes.tableCell}
                                                        >
                                                            <span
                                                                style={{
                                                                    textDecoration: 'underline',
                                                                    cursor: 'pointer',
                                                                    color: '#4C3BCF'
                                                                }}
                                                                onClick={() => { handleRowClick(data.FIS_NO); }}
                                                            >
                                                                {data.FIS_NO}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell className={classes.tableCell}>{data.KUL_BIRIM_KODU}</TableCell>
                                                        <TableCell className={classes.tableCell}>{moment(data.CAGRI_TARIHI).format('DD-MM-YYYY HH:mm:ss')}</TableCell>
                                                        <TableCell className={classes.tableCell}>{moment(data.ISLEM_TARIHI).format('DD-MM-YYYY HH:mm:ss')}</TableCell>
                                                        <TableCell className={classes.tableCell}>{data.ACIKLAMA}</TableCell>
                                                        <TableCell className={classes.tableCell}>{data.BASVURU_NEDENI}</TableCell>
                                                        <TableCell >{data.DURUM_ACIKLAMA}</TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Collapse>
                    </Page>
                </Grid>
            </Grid >
        </>
    )
}

export default MultipleReceiptInquiry
